import { useEffect, useState } from 'react';

// Revela o bloco quando ele entra na viewport (o efeito `reveal` do protótipo).
// A observação é única: depois de visível o elemento sai do observer, para o
// conteúdo não voltar a sumir ao rolar de volta.
//
// O elemento vem por callback ref (state) em vez de useRef: a página monta
// primeiro como <Loading /> e só depois renderiza o conteúdo, então um efeito
// com deps [] leria ref.current = null e nunca observaria nada -- o bloco
// ficava invisível para sempre.
export const useReveal = () => {
  const [node, setNode] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!node || visible) return;

    // Sem IntersectionObserver, ou com movimento reduzido no sistema, o bloco
    // já entra visível -- a animação é decoração, não pode esconder conteúdo.
    if (
      typeof IntersectionObserver === 'undefined' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setVisible(true);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [node, visible]);

  return [setNode, visible];
};
